class AtlasWelcomeKitNote extends HTMLElement {
    connectedCallback() {
        this._productVariants = document.querySelector("product-variants");
        if (!this._productVariants) return;

        const price = this._productVariants.dataset.gwpTotalFormatted;
        if (price) {
            this.querySelectorAll(".welcome-kit-note__price").forEach(
                (el) => (el.textContent = price)
            );
        }

        this._handleToggle = this._handleToggle.bind(this);
        this._productVariants.addEventListener("change", this._handleToggle);

        const checkedToggle = this._productVariants.querySelector(
            ".product-variants-toggle-input:checked"
        );
        this._update(checkedToggle?.value === "subscription");
    }

    _handleToggle(event) {
        if (!event.target.classList.contains("product-variants-toggle-input"))
            return;
        if (!event.target.checked) return;
        this._update(event.target.value === "subscription");
    }

    _update(isSubscription) {
        this.classList.toggle("is-subscription", isSubscription);
    }

    disconnectedCallback() {
        this._productVariants?.removeEventListener(
            "change",
            this._handleToggle
        );
    }
}

if (!customElements.get("atlas-welcome-kit-note")) {
    customElements.define("atlas-welcome-kit-note", AtlasWelcomeKitNote);
}
